import { reactive } from 'vue';

/** A single review dialog serves server duplicate decisions from employee editors. */
export const employeeDuplicateDialog = reactive({ visible: false, matches: [], decision: {}, error: '' });
let finish = null;
export function resolveEmployeeDuplicateDialog(payload = null) {
  const resolve = finish;
  finish = null;
  employeeDuplicateDialog.visible = false;
  resolve?.(payload);
}
export function requestEmployeeDuplicateDecision(matches) {
  resolveEmployeeDuplicateDialog();
  employeeDuplicateDialog.matches = matches;
  employeeDuplicateDialog.decision = {};
  employeeDuplicateDialog.error = '';
  employeeDuplicateDialog.visible = true;
  return new Promise(resolve => { finish = resolve; });
}
